import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { listSearchSchema } from '@/lib/list-search-schema';
import Leads from '@/pages/Leads';

export const leadsSearchSchema = listSearchSchema.extend({
  status: z.string().optional(),
});

export type LeadsSearch = z.infer<typeof leadsSearchSchema>;

export const Route = createFileRoute('/_authenticated/leads')({
  validateSearch: leadsSearchSchema,
  component: Leads,
});
